(function () {
    function setNextDisabled(root, swiper) {
        var disabled = swiper.isEnd;
        root.querySelectorAll('.js-ht-next').forEach(function (btn) {
            btn.disabled = disabled;
            btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        });
    }

    function buildOptions(root, slidesDesktop) {
        return {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 450,
            grabCursor: true,
            watchSlidesProgress: true,
            pagination: {
                el: root.querySelector('.ht-swiper-pagination'),
                type: 'progressbar',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                990: {
                    slidesPerView: slidesDesktop,
                    spaceBetween: 10,
                },
            },
            on: {
                init: function (swiper) {
                    setNextDisabled(root, swiper);
                },
                slideChange: function (swiper) {
                    setNextDisabled(root, swiper);
                },
                reachEnd: function (swiper) {
                    setNextDisabled(root, swiper);
                },
            },
        };
    }

    function ensureNextDelegation(root) {
        if (root.dataset.htNextDelegation === '1') return;
        root.dataset.htNextDelegation = '1';
        root.addEventListener('click', function (e) {
            var btn = e.target.closest('.js-ht-next');
            if (!btn || !root.contains(btn)) return;
            var sw = root.querySelector('[data-history-timeline]');
            if (sw && sw.swiper) sw.swiper.slideNext();
        });
    }

    function ensureProgressBarDelegation(root) {
        if (root.dataset.htProgressDelegation === '1') return;
        root.dataset.htProgressDelegation = '1';
        root.addEventListener('click', function (e) {
            var pag = e.target.closest('.ht-swiper-pagination');
            if (!pag || !root.contains(pag)) return;
            var swEl = root.querySelector('[data-history-timeline]');
            var swiper = swEl && swEl.swiper;
            if (!swiper || !swiper.slides || swiper.slides.length < 2) return;

            var rect = pag.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var ratio = rect.width > 0 ? x / rect.width : 0;
            ratio = Math.max(0, Math.min(1, ratio));

            var last = swiper.slides.length - 1;
            var idx = Math.round(ratio * last);
            idx = Math.max(0, Math.min(last, idx));
            if (typeof swiper.slideTo === 'function') {
                swiper.slideTo(idx, swiper.params.speed);
            }
        });
    }

    function mountTimeline(root) {
        if (typeof Swiper === 'undefined') return;
        var el = root.querySelector('[data-history-timeline]');
        if (!el) return;

        ensureNextDelegation(root);
        ensureProgressBarDelegation(root);

        var slidesDesktop = parseInt(el.getAttribute('data-slides-desktop'), 10) || 3;
        if (el.swiper) el.swiper.destroy(true, true);

        new Swiper(el, buildOptions(root, slidesDesktop));
    }

    function mountAll() {
        document.querySelectorAll('[data-history-timeline]').forEach(function (sw) {
            var root = sw.closest('[id^="shopify-section-"]');
            if (root) mountTimeline(root);
        });
    }

    function boot() {
        mountAll();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
        var root = document.getElementById('shopify-section-' + e.detail.sectionId);
        if (root) mountTimeline(root);
    });
})();